// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file contact.proto (syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2'
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2'
import type { Message } from '@bufbuild/protobuf'

/**
 * Describes the file contact.proto.
 */
export const file_contact: GenFile =
  /*@__PURE__*/
  fileDesc(
    'Cg1jb250YWN0LnByb3RvInUKHUNvbnRhY3RSZXF1ZXN0UHJvcGFnYXRlZFN0YXRlEhMKC2xvY2FsX2Nsb2NrGAEgASgEEhMKC2xvY2FsX3N0YXRlGAIgASgEEhQKDHJlbW90ZV9jbG9jaxgDIAEoBBIUCgxyZW1vdGVfc3RhdGUYBCABKAQi2gEKDUNvbnRhY3RVcGRhdGUSDQoFY2xvY2sYASABKAQSEAoIZW5zX25hbWUYAiABKAkSFQoNcHJvZmlsZV9pbWFnZRgDIAEoCRIUCgxkaXNwbGF5X25hbWUYBCABKAkSHQoVY29udGFjdF9yZXF1ZXN0X2Nsb2NrGAUgASgEEkgKIGNvbnRhY3RfcmVxdWVzdF9wcm9wYWdhdGVkX3N0YXRlGAYgASgLMh4uQ29udGFjdFJlcXVlc3RQcm9wYWdhdGVkU3RhdGUSEgoKcHVibGljX2tleRgHIAEoCSIxChRBY2NlcHRDb250YWN0UmVxdWVzdBIKCgJpZBgBIAEoCRINCgVjbG9jaxgCIAEoBCIyChVSZXRyYWN0Q29udGFjdFJlcXVlc3QSCgoCaWQYASABKAkSDQoFY2xvY2sYAiABKARiBnByb3RvMw',
  )

/**
 * @generated from message ContactRequestPropagatedState
 */
export type ContactRequestPropagatedState =
  Message<'ContactRequestPropagatedState'> & {
    /**
     * @generated from field: uint64 local_clock = 1;
     */
    localClock: bigint

    /**
     * @generated from field: uint64 local_state = 2;
     */
    localState: bigint

    /**
     * @generated from field: uint64 remote_clock = 3;
     */
    remoteClock: bigint

    /**
     * @generated from field: uint64 remote_state = 4;
     */
    remoteState: bigint
  }

/**
 * Describes the message ContactRequestPropagatedState.
 * Use `create(ContactRequestPropagatedStateSchema)` to create a new message.
 */
export const ContactRequestPropagatedStateSchema: GenMessage<ContactRequestPropagatedState> =
  /*@__PURE__*/
  messageDesc(file_contact, 0)

/**
 * @generated from message ContactUpdate
 */
export type ContactUpdate = Message<'ContactUpdate'> & {
  /**
   * @generated from field: uint64 clock = 1;
   */
  clock: bigint

  /**
   * @generated from field: string ens_name = 2;
   */
  ensName: string

  /**
   * @generated from field: string profile_image = 3;
   */
  profileImage: string

  /**
   * @generated from field: string display_name = 4;
   */
  displayName: string

  /**
   * @generated from field: uint64 contact_request_clock = 5;
   */
  contactRequestClock: bigint

  /**
   * @generated from field: ContactRequestPropagatedState contact_request_propagated_state = 6;
   */
  contactRequestPropagatedState?: ContactRequestPropagatedState

  /**
   * @generated from field: string public_key = 7;
   */
  publicKey: string
}

/**
 * Describes the message ContactUpdate.
 * Use `create(ContactUpdateSchema)` to create a new message.
 */
export const ContactUpdateSchema: GenMessage<ContactUpdate> =
  /*@__PURE__*/
  messageDesc(file_contact, 1)

/**
 * @generated from message AcceptContactRequest
 */
export type AcceptContactRequest = Message<'AcceptContactRequest'> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string

  /**
   * @generated from field: uint64 clock = 2;
   */
  clock: bigint
}

/**
 * Describes the message AcceptContactRequest.
 * Use `create(AcceptContactRequestSchema)` to create a new message.
 */
export const AcceptContactRequestSchema: GenMessage<AcceptContactRequest> =
  /*@__PURE__*/
  messageDesc(file_contact, 2)

/**
 * @generated from message RetractContactRequest
 */
export type RetractContactRequest = Message<'RetractContactRequest'> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string

  /**
   * @generated from field: uint64 clock = 2;
   */
  clock: bigint
}

/**
 * Describes the message RetractContactRequest.
 * Use `create(RetractContactRequestSchema)` to create a new message.
 */
export const RetractContactRequestSchema: GenMessage<RetractContactRequest> =
  /*@__PURE__*/
  messageDesc(file_contact, 3)
